let backendDown = false;

const listeners: ((v: boolean) => void)[] = [];

export function setBackendDown(value: boolean) {
  backendDown = value;
  listeners.forEach(fn => fn(value));
}

export function subscribeBackendStatus(fn: (v: boolean) => void) {
  listeners.push(fn);
  fn(backendDown);

  return () => {
    const i = listeners.indexOf(fn);
    if (i > -1) listeners.splice(i, 1);
  };
}